import { Component, OnInit } from '@angular/core';
import { DropdownService } from '../common/services/dropdown.service';
import { ExternalLinkService } from '../common/services/external-link.service';

@Component({
    selector: 'app-about',
    templateUrl: './about.component.html',
    styleUrls: ['./about.component.scss'],
  standalone: true,
  imports: []
})
export class AboutComponent implements OnInit {
  globalDefaults: any[] | null;
  public supportEmail: any;

  constructor(private dropdownService: DropdownService, public externalLinkService: ExternalLinkService) { }

  ngOnInit(): void {
    this.dropdownService.getGlobalDefaults().then(gd => {
      this.supportEmail = gd.find(x => x.globalDefaultId == "SupportEmail")?.textValue
    });
  }
}
